import React from "react";
import error from "../../Resources/svg/error.svg";
import { generateQuote } from "../../Store/simulate/actions";
import { useDispatch } from "react-redux";

interface Props {
  data: any;
  open: any;
  handleClick: any;
  navigationNext: any;
  setErrorServiceUpdateSAS: any;
}

function ModalAlert({
  data,
  open,
  handleClick,
  navigationNext,
  setErrorServiceUpdateSAS,
}: Props) {
  const dispatch = useDispatch();
  const goProcessQuote = () => {
    handleClick();
    setErrorServiceUpdateSAS(true);
    dispatch(generateQuote(true));
  };

  return (
    <div className={`modalCustom ${open ? "is-open" : ""}`}>
      <div className="modalCustom__container">
        <img
          src={error}
          alt="image"
          className="modalCustom__container__image"
        />
        {data.errorCreate && (
          <>
            <div>{data.message}</div>
            <button
              type="button"
              className="buttonCustom sm"
              onClick={handleClick}
            >
              <span>{data.btnText}</span>
            </button>
          </>
        )}
        {data.errorUpdate && (
          <>
            <div>{data.message}</div>
            <div className="modalCustom__wapper-buttons">
              <button
                type="button"
                className="buttonCustom sm"
                onClick={goProcessQuote}
              >
                <span>SI</span>
              </button>
              <button
                type="button"
                className="buttonCustom sm"
                onClick={navigationNext}
              >
                <span>NO</span>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default ModalAlert;
